export const HARDCODED_CALCULATION_METHODS = [
    {
        id: 0,
        name: 'משקל'
    },
    {
        id: 1,
        name: 'יחידות'
    }
]